import React from 'react';
import { Redirect } from 'react-router-dom';
import authRoutes from 'routes/globalRoutes/auth';
import myProfileRoutes from 'routes/globalRoutes/myProfile';
import PATH from 'routes/paths';

const AccountingDashboardRedirect = () => {
  return <Redirect to="/internal-requests?status=pendingClosed&page=1" />;
};

export const DASHBOARD = {
  component: AccountingDashboardRedirect,
  path: PATH.DASHBOARD,
  exact: true,
  isProtected: true,
};

let routes = [];
const routeFiles = require.context('./', true, /^(?!.\/index|.\/paths).*\.js$/);

routeFiles.keys().forEach((routeFile) => {
  routes = [...routes, ...routeFiles(routeFile).default];
});

const accountingRoutes = [
  ...authRoutes,
  ...myProfileRoutes,
  ...routes,
  DASHBOARD,
];

export default accountingRoutes;
